import axios from 'axios'
import store from '@/store'

import Vue from 'vue'
let vm = new Vue()

import { getToken, removeToken } from '@/utils/auth'
import { addRequireHeader } from '@/utils/judge-browser'

import router, { resetRouter } from '@/router'
axios.defaults.headers['X-yoogurt-api-version'] = 'v1'
axios.defaults.headers['X-yoogurt-system-type'] = '1'
const service = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

service.interceptors.request.use(
  config => {
    // if (config.data) {
    //   config.headers['Content-Type'] = 'application/json';
    //   config.data = JSON.stringify(config.data);
    // }
    config.headers['Authorization'] = getToken() || ''
    config.headers['X-yoogurt-browser-model'] = addRequireHeader() ? addRequireHeader().browser : 'unknown'
    config.headers['X-yoogurt-system-version'] = addRequireHeader() ? addRequireHeader().version : 'unknown'
    // console.log('store.getters.uuid', store.getters.uuid)
    config.headers['yoogurt-request-id'] = store.getters.uuid
    config.headers['X-yoogurt-system-name'] = 'taxi_bbc'
    // console.log(config);
    return config
  },

  error => {
  // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  })
service.interceptors.response.use(
  response => {
      const res = response.data
      if (res && res.status) {
          if (res.status !== 200) {
              if (res.status === 401 || res.status === 403) {
                // Notification.error({ title: '错误', message: res.message })
                store.dispatch('logout',).then(() => {
                  // router.replace({ path: '/' })
                })
                router.replace('/login')
              }else{
                // Notification.error({ title: '错误', message: res.message })
                vm.$toast({
                  title: '提示',
                  content: res.message,
                  type: 'warning',
                  onShow: () => {
                    console.log('on toast show')
                  },
                  onHide: () => {
                    console.log('on toast hide')
                  }
                })
                console.error(res.message)
              }
              
          }
          return Promise.resolve(res)
      } else {
          return Promise.resolve(response)
      }
  },
  error => {
    console.error(error) // for debug
    // Notification.error({ title: '错误', message: '系统繁忙' })
    return Promise.reject(error)
  }

)

export default service
